import { __extends } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { namespacedClassnames } from '../../common/namespace-classes';
import { DeprecatedText } from '../../deprecated-typography';
import { EllipsisText } from '../ellipsis-text/ellipsis-text';
// tslint:disable-next-line:no-var-requires
var copyToClipboard = require('copy-to-clipboard');
export var compKey = 'click-to-copy';
var ClickToCopy = /** @class */ (function (_super) {
    __extends(ClickToCopy, _super);
    function ClickToCopy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            copied: false,
            hasEllipsis: false
        };
        _this.copiedMsgTimeout = 4000;
        _this.element = null;
        _this.timer = null;
        _this.copy = function () {
            clearTimeout(_this.timer);
            copyToClipboard(_this.props.text);
            _this.setState({ copied: true });
            _this.timer = setTimeout(function () { return _this.setState({ copied: false }); }, _this.copiedMsgTimeout);
            var selection = window.getSelection && window.getSelection();
            if (_this.element && selection) {
                var range = document.createRange();
                range.selectNode(_this.element);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        };
        _this.setRef = function (ref) {
            _this.element = ref ? ReactDOM.findDOMNode(ref) : null;
        };
        _this.onEllipsisChange = function (hasEllipsis) {
            _this.setState({ hasEllipsis: hasEllipsis });
        };
        _this.calcTooltipText = function () {
            var _a = _this, props = _a.props, state = _a.state;
            var ttText = props.t("common.click-to-copy" + (state.copied ? '.copied' : ''));
            // if we're showing the rest of the ellipsised text we need to prepend the "click to copy part"
            if (state.hasEllipsis && !state.copied) {
                return props.text + " | " + ttText;
            }
            else {
                return ttText;
            }
        };
        return _this;
    }
    ClickToCopy.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var cm = namespacedClassnames(compKey, props.className, { copied: state.copied });
        var ttText = this.calcTooltipText();
        var innerElementHover = props.clickableElement ?
            React.createElement("div", { onClick: this.copy }, props.clickableElement) :
            React.createElement(DeprecatedText, { onClick: this.copy, type: props.type }, props.text);
        return (React.createElement(EllipsisText, { ref: this.setRef, tooltipText: !this.props.preCopyTooltipBody || state.copied ? ttText : undefined, tooltipBody: state.copied ? undefined : this.props.preCopyTooltipBody, forceTooltip: true, forceTooltipVisible: state.copied, onEllipsisChange: this.onEllipsisChange, className: cm, direction: props.direction, tooltipRelativeToBody: true }, innerElementHover));
    };
    return ClickToCopy;
}(React.PureComponent));
export { ClickToCopy };
//# sourceMappingURL=index.js.map